import { TextField } from '@mui/material';
import React, { forwardRef } from 'react';
import { useTranslation } from 'react-i18next';
import { isValidPhoneNumber } from 'react-phone-number-input';
import PhoneInput from 'react-phone-number-input/react-hook-form-input';

const WrapPhoneInput = (props, ref) => {
  const { t } = useTranslation('global');
  return (
    <TextField
      {...props}
      inputRef={ref}
      fullWidth
      size="small"
      label={t('modalProfile.phone')}
      variant="outlined"
      name="phone"
      helperText={props.isSignIn && t('signIn.phoneHelper')}
      inputProps={{
        'data-testid': 'profile-phone',
      }}
    />
  );
};

const forwardInput = forwardRef(WrapPhoneInput);

const ProfilePhone = ({ control, data, errors }) => {
  return (
    <PhoneInput
      name="phone"
      country="US"
      control={control}
      defaultValue={data?.phone}
      inputComponent={forwardInput}
      error={!!errors.phone}
      rules={{
        required: false,
        validate: value => !value || isValidPhoneNumber(value),
      }}
    />
  );
};

export default ProfilePhone;
